import React from 'react';
import ReactDOM from "react-dom/client";
import {
  createBrowserRouter, 
  RouterProvider,
  useLoaderData, 
  Navigate, 
  useNavigation,
  Outlet,
  useRevalidator, 
  redirect } from 'react-router-dom';
import './libs/fontawesome-6.5.1-web/scss/fontawesome.scss';
import './libs/fontawesome-6.5.1-web/scss/solid.scss';
import './libs/fontawesome-6.5.1-web/scss/brands.scss';
import * as serviceWorker from './serviceWorker';
import LoadingFullscreen from './components/loading/loading_fullscreen';
import { AuthContext } from './contexts';
import { AdminFrame } from './components/admin_frame/admin_frame';
import loginRoutes from './views/login/routes';
import staffRoutes from './views/staff/routes';
import documentRoutes from './views/document/routes';
import complaintTypeRoutes from './views/complaint_type/routes';
import clinicRoutes from './views/clinic/routes';
import patientRoutes from './views/patient/routes';
import complaintCaseRoutes from './views/complaint_case/routes';
import { complaintCaseFormRoutes, complaintCaseFormHashRoutes } from './views/complaint_case_form/routes';
import { desktopRoutes } from './views/desktop/routes';
import { AuthProvider } from './auth_provider';
import { LOGIN_PATH } from './constants/paths';
import './init.scss';
import './index.scss';

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pageLoaded: true
    };

    sessionStorage.clear();
  }

  async onLogout() {
    this.setState({
      pageLoaded: false,
    });

    try {
      if(await AuthProvider.signOut()) {
        this.setState({
          pageLoaded: true
        });

        this.props.revalidator.revalidate();

        return;
      }
    }
    catch(errors) {      
      if(errors instanceof Array) {
        for(let error of errors) {
          switch (error.code) {
            case 209:
              this.setState({
                pageLoaded: true
              });

              return;
            default:
          }
        }
      }

      return;
    }

    window.alert('Infelizmente estamos com problemas em nosso serviço. Por favor, tente novamente mais tarde.');

    this.setState({
      pageLoaded: true,
    });
  }

  getAuthContextValue() {
    return {
      user_id: this.props.authData.user_id,
      username: this.props.authData.username,
      access_level: this.props.authData.access_level,
      permission_ids: this.props.authData.permission_ids
    };
  }

  render() {    
    return (
      <AuthContext.Provider value={this.getAuthContextValue()}>

        <AdminFrame
          onLogout={() => this.onLogout()}
        >

          <Outlet />

        </AdminFrame>

        <LoadingFullscreen 
          visible={!this.state.pageLoaded || this.props.revalidator.state === "loading"}
        />

      </AuthContext.Provider>
    );
  }
};

const WrappedApp = props => {
  const authData = useLoaderData();
  const navigation = useNavigation();
  let revalidator = useRevalidator();

  return (
    <App
      authData={authData}
      navigation={navigation}
      revalidator={revalidator}
      {...props}
    />
  );
};

const router = createBrowserRouter([
  {
    path: "/",
    element: <WrappedApp />,
    loader: async ({request}) => {      
      if (!AuthProvider.is_authenticated) {
        await AuthProvider.isAuthenticated();
      }

      if (!AuthProvider.is_authenticated) {
        const url = new URL(request.url);

        AuthProvider.setRedirectTo(url.pathname)
        return redirect(LOGIN_PATH);
      }

      return AuthProvider.getParameters();
    },
    // errorElement: <h1>Error</h1>,
    children: [
      ...staffRoutes,
      ...documentRoutes,
      ...complaintTypeRoutes,
      ...clinicRoutes,
      ...patientRoutes,
      ...complaintCaseRoutes,
      ...complaintCaseFormRoutes,
      ...desktopRoutes
    ]
  },
  ...loginRoutes,
  ...complaintCaseFormHashRoutes,
  {
    path: '*',
    element: <Navigate to="/" replace={true} />
  }
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>

    <RouterProvider router={router} />

  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
